export default __webpack_public_path__ + "img/1992c64db422354dd1a60401593f7b4f.svg";